import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../model/formBuilderInterface';
import { validationMessage } from '../../../../constants/constant';
import { CommonService } from '../../../shared/services/common.service';
import { REGEX } from 'src/app/core/validation';

@Component({
  selector: 'app-file-upload-input',
  templateUrl: './file-upload-input.component.html',
  styleUrls: ['./file-upload-input.component.scss']
})
export class FormFileUploadInputComponent {
  @Input() field: Field;
  @Input() form: FormGroup;
  @ViewChild('fileInput') fileInput: ElementRef;
  constructor(private readonly cs: CommonService) {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      if (!selectedFile.type) {
        this.cs.showErrorMessage(validationMessage.ONLY_FILES_ALLOWED);
        return;
      }
      if (
        this.field.fileSizeLimit &&
        selectedFile?.size > this.field.fileSizeLimit
      ) {
        this.cs.showErrorMessage(
          validationMessage.FILE_SIZE_LIMIT.replace(
            '[fileSize]',
            `${this.field.fileSizeLimit / (1024 * 1024)}`
          )
        );
        return;
      }
      const control = this.form.get(this.field.name);
      if (control) {
        // Set the file object and its metadata in the form control
        control.setValue({
          file: selectedFile,
          name: selectedFile.name,
          size: selectedFile.size,
          type: selectedFile.type,
          lastModified: selectedFile.lastModified
        });
      }
    }
  }
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  get fileFieldName(): string {
    if (this.form.get(this.field.name)?.value?.name) {
      return this.form.get(this.field.name).value.name;
    }
    const originalFileName = this.form.get(this.field.name)?.value.match(REGEX.PREFIX_IMAGE_URL);
    return originalFileName[1];
  }
}
